<template>
  <div v-if="!item.hidden">
    <router-link v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow" :to="resolvePath(item.path)">
      <el-menu-item :index="resolvePath(item.path)">
        <svg-icon v-if="item.meta.icon" :icon-class="item.meta.icon" />

        <template slot="title">
          <span>{{ item.name }}</span>
        </template>
      </el-menu-item>
    </router-link>

    <el-submenu v-else popper-class="side-bar-popper" :index="item.name">
      <template slot="title">
        <svg-icon v-if="item.meta.icon" :icon-class="item.meta.icon" />
        <span>{{ item.name }}</span>
      </template>
      <sidebar-item v-for="route in item.children" :key="route.path" :is-nest="true" :base-path="resolvePath(item.path)" :item="route" />
    </el-submenu>
    <!-- <sidebar-item
      v-else-if="Array.isArray(item.children)&&item.children.length===1"
      :base-path="resolvePath(item.path)"
      :item="item.children[0]"
    /> -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  data() {
    this.onlyOneChild = null;
    return {};
  },
  computed: {
    ...mapGetters([
      'routes',
    ]),
  },
  methods: {
    resolvePath(path) {
      const resolvePath = [];
      let basePath = this.basePath;
      if (basePath) {
        if (basePath.startsWith('/')) {
          basePath = basePath.substring(1);
        }
        resolvePath.push(basePath);
      }
      if (path) {
        if (path.startsWith('/')) {
          path = path.substring(1);
        }
        resolvePath.push(path);
      }
      return '/' + resolvePath.join('/');
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true };
        return true;
      }

      return false;
    },
  },

};
</script>
<style lang="less">
#app {
  .el-scrollbar__view {
    height: calc(100vh - 66px);
    overflow-x: hidden;
  }
  .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;

    .svg-icon {
      margin-right: 10px;
      width: 1.5rem;
      height: 1.5rem;
    }
  }
  .el-menu-item,
  .el-submenu__title {
    height: 70px;
    line-height: 70px;
  }
  .el-submenu .el-menu-item {
    height: 70px;
    line-height: 70px;
    padding: 0 60px !important;
  }
  .el-menu-item {
    padding-left: 26px !important;
    background: #000000;
    color: #fff;
    font-size: 16px;
    display: flex;
    align-items: center;
    a {
      display: block;
      color: #fff;
    }
  }
  .el-menu-item.is-active {
    background: #3c0609 !important;
    color: #fff;
  }
  .el-submenu__title {
    padding-left: 26px !important;
    font-size: 16px;
    display: flex;
    align-items: center;
  }
  .el-submenu__title.is-active {
    background: #3c0609 !important;
  }

  .el-submenu__title:hover {
    background: #3c0609 !important;
  }
  .el-icon-arrow-down:before {
    color: #fff;
  }
}
</style>
